module.exports = __webpack_public_path__ + "img/sec4_box3.be20274f.png";